<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-v-79b1a798=""
  >
    <rect
      opacity="0.3"
      x="2"
      y="2"
      width="20"
      height="20"
      rx="10"
      fill="currentColor"
      data-v-79b1a798=""
    ></rect>
    <path
      d="M10.4343 12.4343L8.75 10.75C8.33579 10.3358 7.66421 10.3358 7.25 10.75C6.83579 11.1642 6.83579 11.8358 7.25 12.25L10.2929 15.2929C10.6834 15.6834 11.3166 15.6834 11.7071 15.2929L17.25 9.75C17.6642 9.33579 17.6642 8.66421 17.25 8.25C16.8358 7.83579 16.1642 7.83579 15.75 8.25L11.5657 12.4343C11.2533 12.7467 10.7467 12.7467 10.4343 12.4343Z"
      fill="currentColor"
      data-v-79b1a798=""
    ></path>
  </svg>
</template>
